import React from 'react';
import { NavigateToLogin } from './NavigateToLogin';

export type MaybeComponentOrRedirectToLoginProps = {
  /** The component to render if the condition passes */
  component: React.ComponentType;
  /** The condition to check to determine if the component should be rendered */
  condition: (() => boolean) | boolean;
};

/**
 * Component that renders the component passed if the condition passes, otherwise redirects to the login page.
 */
export function MaybeComponentOrRedirectToLogin({
  component: Component,
  condition: _condition,
}: MaybeComponentOrRedirectToLoginProps) {
  // Ensure the condition at runtime is an expected type/shape to prevent issues at runtime
  if (typeof _condition !== 'function' && typeof _condition !== 'boolean') {
    return <NavigateToLogin />;
  }

  const condition = typeof _condition === 'function' ? _condition() : _condition;

  if (condition) {
    return <Component />;
  }

  return <NavigateToLogin />;
}
